import { TeacherResourcesFeatureFlagType } from '../types';
import { createStandardAction } from 'typesafe-actions';

export const setTeacherResourcesFeatureFlag = createStandardAction(
  'TEACHERRESOURCES/FEATURE_FLAG'
)<TeacherResourcesFeatureFlagType>();
